/* Ott-common */
import { ClientType } from '@dtvgo/backend-service/normalize';
import { Platform as AemPlatform } from '@dtvgo/aem-service';

/* Utils */
import { BACK, CHANNEL_DOWN, CHANNEL_UP } from './keyCodes';
import {
  closeApp,
  sendAppToBackground,
  getDeviceInfo,
  isTizen,
  registerKeys,
  getTimezone,
  getAppId,
  getWebapisApi,
  getConnectionStatus,
  saveCredentials,
  getCredentials,
  removeCredentials,
  getUrlToOpen,
  addRelaunchEventListener,
  getAppVersion,
} from './general';
import { isInsideIFrame, onMessage } from './messages';
import { MsToWaitOnReconnection, Platform } from '../../constants';

const SESSION_TOKEN_ALTERNATIVE_KEY = 'authToken';
function init() {
  getWebapisApi();
  if (isInsideIFrame) window.addEventListener('message', onMessage);
  registerKeys();
}

export default {
  osName: 'TIZEN',
  platformName: 'Tizen',
  isTizen: true,
  signupUrl: '/samsung',
  appName: 'samsung_tv',
  aemPlatform: AemPlatform.TIZEN,
  clientType: ClientType.SAMSUNG,
  isThisPlatform: isTizen,
  init,
  // App and device info
  getAppId,
  getTimezone,
  getDeviceInfo,
  getUrlToOpen,
  // Functions
  closeApp,
  sendAppToBackground,
  getConnectionStatus,
  msToWaitOnReconnection: MsToWaitOnReconnection[Platform.TIZEN],
  saveCredentials,
  getCredentials,
  removeCredentials,
  getSessionTokenAlternative: () => getCredentials(SESSION_TOKEN_ALTERNATIVE_KEY),
  removeSessionTokenAlternative: () => {
    removeCredentials(SESSION_TOKEN_ALTERNATIVE_KEY);
  },
  // Player related options
  isPlayreadyUtf8AndPlain: true,
  addRelaunchEventListener,
  // Conviva
  npaw: {
    name: 'Samsung',
  },
  // Key codes
  keyCodes: {
    back: BACK,
    channel: {
      up: CHANNEL_UP,
      down: CHANNEL_DOWN,
    },
  },
  datadog: {
    useCrossSiteSessionCookie: true,
  },
  getAppVersion,
};
